export default {
    GET_ADDITIONAL_LOCATION: (state)=> {
        return state.additionalLocations
    },
    GET_LOCATION_TYPE: (state)=> {
        return state.locationTypes
    }
}